// dbXrefUrlMap.js
const dbXRefURLMap = {
  "geneid":      id => `https://www.ncbi.nlm.nih.gov/gene/${id}`,
  "hgnc":        id => `https://www.genenames.org/data/gene-symbol-report/#!/hgnc_id/HGNC:${id}`,
  "mim":         id => `https://omim.org/entry/${id}`,
  "uniprotkb":   id => `https://www.uniprot.org/uniprot/${id}`,
  "uniprotkb/trembl": id => `https://www.uniprot.org/uniprot/${id}`,
  "uniprotkb/swiss-prot": id => `https://www.uniprot.org/uniprot/${id}`,
  "pdb":         id => `https://www.rcsb.org/structure/${id}`,
  "refseq":      id => `https://www.ncbi.nlm.nih.gov/nuccore/${id}`,
  "go":          id => `http://amigo.geneontology.org/amigo/term/GO:${id}`,
  "ensembl":     id => `https://www.ensembl.org/id/${id}`,
  "zfin":        id => `https://zfin.org/${id}`,
  "flybase":     id => `https://flybase.org/reports/${id}`,
  "wormbase":    id => `https://wormbase.org/species/all/gene/${id}`,
  "tair":        id => `https://www.arabidopsis.org/servlets/TairObject?type=locus&name=${id}`,
  "genedb":      id => `https://www.genedb.org/gene/${id}`,
  "ecogene":     id => `https://ecogene.org/gene/${id}`,
  "kegg":        id => `https://www.genome.jp/dbget-bin/www_bget?${id}`,
  "interpro":    id => `https://www.ebi.ac.uk/interpro/entry/${id}`,
  "pfam":        id => `https://www.ebi.ac.uk/interpro/entry/pfam/${id}`,
  "rnacentral":  id => `https://rnacentral.org/rna/${id}`,
  "pombase":     id => `https://www.pombase.org/gene/${id}`,
  "dictybase":   id => `https://dictybase.org/gene/${id}`,
  "sgd":         id => `https://www.yeastgenome.org/locus/${id}`,
  "rgd":         id => `https://rgd.mcw.edu/rgdweb/search/search.html?term=${id}`,
  "mgi":         id => `http://www.informatics.jax.org/accession/MGI:${id}`,
  "medgen":      id => `https://www.ncbi.nlm.nih.gov/medgen/${id}`,
  "dbsnp":       id => `https://www.ncbi.nlm.nih.gov/snp/${id}`,
  "dbest":       id => `https://www.ncbi.nlm.nih.gov/nucest/${id}`,
  "mirbase":     id => `http://www.mirbase.org/cgi-bin/query.pl?terms=${id}`,
  "vectorbase":  id => `https://vectorbase.org/${id}`,
  "phytozome":   id => `https://phytozome-next.jgi.doe.gov/info/${id}`,
  "vista":       id => `https://enhancer.lbl.gov/cgi-bin/imagedb3.pl?show=1;experiment=${id}`,
  "rfam":        id => `https://rfam.org/search?q=${id}`,

  // Using identifiers.org for various databases
  "aceview/wormgenes": id => `https://identifiers.org/aceview.worm:${id}`,
  "antweb": id => `https://identifiers.org/antweb:${id}`,
  "apidb_cryptodb": id => `https://identifiers.org/cryptodb:${id}`,
  "apidb_plasmodb": id => `https://identifiers.org/plasmodb:${id}`,
  "apidb_toxodb": id => `https://identifiers.org/toxoplasma:${id}`,
  "asap": id => `https://identifiers.org/asap:${id}`,
  "atcc": id => `https://identifiers.org/atcc:${id}`,
  "beetlebase": id => `https://identifiers.org/beetlebase:${id}`,
  "dbprobe": id => `https://identifiers.org/dbprobe:${id}`,
  "goa": id => `https://identifiers.org/goa:${id}`,
  "vega": id => `https://identifiers.org/vega:${id}`,
  "xenbase": id => `https://identifiers.org/xenbase:${id}`,
};

export default dbXRefURLMap;